import React from "react";
import Header from "./common/Header";
import Footer from "./common/Footer";
import Main from "../router/Main";

import "../scss/common/common.scss";

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Main></Main>
      <Footer></Footer>
    </div>
  );
}

export default App;
